/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of Zuum Transportation Inc.
 #*
 #* Copyright Zuum 2015-2019. All Rights Reserved.
 #*
 #*===================================================================
 */

import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
// Rxjs
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
// Models
import { CompanyTypesEnum, ContactInfoTypeEnum, ContactInfo, IApiResponse } from '@truckstop-tms/zuum-lib';
// Services
import { ApiService } from 'app/services/api.service';

@Injectable({
  providedIn: 'root',
})
export class ContactInfoService {
  constructor(private http: HttpClient, private apiService: ApiService) {}

  saveContactInfoById(
    contactInfoId: number | null | undefined,
    contactInfo: Partial<ContactInfo>,
    logActivity = true
  ): Observable<IApiResponse<ContactInfo>> {
    const url = `${this.apiService.superAdminApi}/contact-info/${contactInfoId}?logActivity=${logActivity}`;
    return this.http
      .post<IApiResponse>(url, contactInfo)
      .pipe(catchError((error: HttpErrorResponse) => throwError(error)));
  }

  getContactInfo(clientId: number, companyType: CompanyTypesEnum): Observable<IApiResponse<ContactInfo[]>> {
    const url = `${this.apiService.superAdminApi}/contact-info/${clientId}/${companyType}`;
    return this.http.get<IApiResponse>(url).pipe(catchError((error: HttpErrorResponse) => throwError(error)));
  }

  getContactInfoByClientId(clientId: number): Observable<IApiResponse<ContactInfo[]>> {
    const url = `${this.apiService.superAdminApi}/contact-info/client-id/${clientId}`;
    return this.http.get<IApiResponse>(url).pipe(catchError((error: HttpErrorResponse) => throwError(error)));
  }

  getContactInfoByClientIdAndType(clientId: number, type: ContactInfoTypeEnum): Observable<IApiResponse<ContactInfo>> {
    const url = `${this.apiService.superAdminApi}/contact-info/by-client-id-and-type/${clientId}/${type}`;
    return this.http.get<IApiResponse>(url).pipe(catchError((error: HttpErrorResponse) => throwError(error)));
  }
}
